'use strict';

module.exports = '3.22.1';



//////////////////
// WEBPACK FOOTER
// ./node_modules/algoliasearch/src/version.js
// module id = 35
// module chunks = 0